import PolicyTerms from "./policyTerms";

export default PolicyTerms;
